import { Component, computed, Inject, OnInit, Signal } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { FishTicket } from '../shared/delivery-fish-ticket.model';
import { LocalStorageService } from '../shared/local-storage.service';
import { duplicateTicketValidator, fishTicketValidator } from '../shared/trip-validator.model';
import { ToastrService } from 'ngx-toastr';

/**
 * Dialog for adding a fish ticket on the current delivery page.
 * Can also add a new buyer from this dialog.
 */
@Component({
    selector: 'app-add-ticket-dialog',
    templateUrl: './add-ticket-dialog.component.html',
    styleUrls: ['./add-ticket-dialog.component.css'],
    standalone: false
})
export class AddTicketDialogComponent implements OnInit {

  /**
   * Tickets require a buyer, number, and date
   */
  ticketForm = new FormGroup({
    buyer: new FormControl('', [Validators.required, Validators.pattern('^[A-z0-9 ]+$')]),
    number: new FormControl('', [Validators.required, fishTicketValidator()]),
    date: new FormControl(new Date(), [Validators.required])
  });

  newBuyerControl = new FormControl('', [Validators.required, Validators.pattern('^[A-z0-9 ]+$')]);

  maxDate = new Date();
  newBuyer: boolean = false;
  buyers: Signal<string[]>;
  currentBuyer: string = "";

  constructor(public dataSync: LocalStorageService, public dialogRef: MatDialogRef<AddTicketDialogComponent>, private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: {tckt: FishTicket, usedNums: string[]}) {
      this.buyers = computed(() => this.dataSync.delivery_buyers());
     }

  ngOnInit(): void {
    this.ticketForm.patchValue({
      buyer: this.data.tckt.buyer,
      number: this.data.tckt.ticketNumber,
      date: this.data.tckt.deliveryDate
    });
    this.ticketForm.get('number')?.addValidators(duplicateTicketValidator(this.data.usedNums));
    this.ticketForm.get('number')?.updateValueAndValidity();
    this.currentBuyer = this.data.tckt.buyer;
  }


  confirmTicket() {
    if (this.ticketForm.valid) {
      this.dialogRef.close(this.ticketForm.value);
    }   
  }


  deleteTicket() {
    this.dialogRef.close({delete: true});
  }


  addNewBuyer(change: MatSelectChange) {
    if (change.value) {
      this.ticketForm.get('buyer')?.setValue(change.value);
      this.currentBuyer = change.value;
    } else {
      this.newBuyer = true;
      this.ticketForm.get('buyer')?.setValue(this.currentBuyer);

    }
  }


  confirmNewBuyer() {
    if (this.newBuyerControl.valid) {
      this.dataSync.addAuxiliaryData(this.newBuyerControl.value!, 'delivery_buyers').then(res => {
        if (res.success) {
          this.newBuyer = false;
          this.ticketForm.get('buyer')?.setValue(this.newBuyerControl.value!);
          this.newBuyerControl.reset();
        } else {
          this.toastr.error('Error adding new buyer', 'Error');
        }
        
      });  
   }
  }

}
